import { lazy, Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  CheckoutLayout,
  LoadingLayout,
  Loading
} from 'common/components/layout';
import { retry } from 'common/helpers/routerHelper';
import { getClubSignup, getVirtualCart } from 'redux/clubSignup/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

const LoadableComponent = lazy(() => retry(() => import('./ClubSignupApp')));

const ClubSignupAppLoader = () => {
  const dispatch = useDispatch();
  const { t } = useLocalization();
  const clubSignupReducer = useSelector((state) => state.clubSignup);
  const virtualCart = useSelector((state) => state.clubSignup.virtualCart);

  useEffect(() => {
    dispatch(getClubSignup());
  }, [dispatch]);

  useEffect(() => {
    if (!virtualCart) {
      dispatch(getVirtualCart(clubSignupReducer.data?.id));
    }
  }, [dispatch, clubSignupReducer.data?.id, virtualCart]);

  if (!clubSignupReducer.data || !clubSignupReducer.virtualCart) {
    return <LoadingLayout />;
  }

  return (
    <CheckoutLayout title={t('clubSignup.signup.clubSignup')}>
      <Suspense fallback={<Loading />}>
        <LoadableComponent />
      </Suspense>
    </CheckoutLayout>
  );
};

export default ClubSignupAppLoader;
